// extracted by mini-css-extract-plugin
module.exports = {"container":"global-module--container--2hj5p","screen":"global-module--screen--GGQBM","case":"global-module--case--3k1pl"};